import {
  AirVent,
  AlarmSmoke,
  Anchor,
  Antenna,
  Apple,
  Archive,
  Armchair,
  AtSign,
  Award,
  Axe,
  BadgeDollarSign,
  BadgeEuro,
  Banknote,
  Bath,
  Battery,
  BatteryCharging,
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  BatteryWarning,
  Bed,
  BedDouble,
  BedSingle,
  Beef,
  Beer,
  Bell,
  BellRing,
  Bike,
  Bird,
  Bluetooth,
  Bolt,
  Book,
  Bookmark,
  BookOpen,
  Box,
  Boxes,
  BrickWall,
  BrickWallFire,
  Briefcase,
  BriefcaseMedical,
  Brush,
  BrushCleaning,
  Bug,
  Building,
  Building2,
  Bus,
  Cable,
  Cake,
  CakeSlice,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  Camera,
  Car,
  Caravan,
  CarFront,
  Carrot,
  Cast,
  Castle,
  Cat,
  Cctv,
  Check,
  CheckCheck,
  ChefHat,
  Cherry,
  CircleAlert,
  CircleCheck,
  CircleParking,
  CirclePower,
  CircleQuestionMark,
  CircleUser,
  CircleUserRound,
  CircleX,
  Clipboard,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cloud,
  CloudDrizzle,
  CloudFog,
  CloudLightning,
  CloudRain,
  CloudSnow,
  CloudSun,
  Cloudy,
  Clover,
  Coffee,
  Coins,
  Compass,
  Component,
  Cone,
  Construction,
  Contact,
  ContactRound,
  Cookie,
  CookingPot,
  Copy,
  Cpu,
  CreditCard,
  Croissant,
  Crosshair,
  CupSoda,
  Cylinder,
  Diamond,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Dog,
  DollarSign,
  DoorClosed,
  DoorClosedLocked,
  DoorOpen,
  Drill,
  Droplet,
  DropletOff,
  Droplets,
  Dumbbell,
  Earth,
  Egg,
  Ellipsis,
  EllipsisVertical,
  Euro,
  Eye,
  EyeOff,
  Fan,
  Feather,
  Fence,
  File,
  FileAudio,
  FileCheck,
  FileCode,
  FileImage,
  FileMinus,
  FileMusic,
  FilePlus,
  FileText,
  FileVideo,
  FileX,
  Filter,
  FireExtinguisher,
  Fish,
  Flag,
  Flame,
  FlameKindling,
  Flower,
  Flower2,
  Folder,
  FolderCheck,
  FolderKey,
  FolderLock,
  FolderMinus,
  FolderOpen,
  FolderPlus,
  FolderX,
  Footprints,
  Forklift,
  Frown,
  Gamepad,
  Gamepad2,
  Gauge,
  Gem,
  Gift,
  Glasses,
  Globe,
  Grape,
  Grip,
  GripHorizontal,
  GripVertical,
  Hamburger,
  Hammer,
  Hand,
  HandCoins,
  HandHeart,
  HandHelping,
  Handshake,
  HardDrive,
  HardDriveDownload,
  HardDriveUpload,
  HardHat,
  Hash,
  Heart,
  HeartPulse,
  Heater,
  Hexagon,
  Hourglass,
  House,
  HousePlug,
  HousePlus,
  HouseWifi,
  IceCreamBowl,
  IceCreamCone,
  Inbox,
  Info,
  Key,
  KeyRound,
  KeySquare,
  Lamp,
  LampCeiling,
  LampDesk,
  LampFloor,
  LampWallDown,
  LampWallUp,
  Laptop,
  Layers,
  Layers2,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  Leaf,
  LeafyGreen,
  Lightbulb,
  LightbulbOff,
  Lock,
  LockKeyhole,
  LockOpen,
  Luggage,
  Magnet,
  Mail,
  Mailbox,
  MailOpen,
  MapPin,
  MapPinHouse,
  Medal,
  Meh,
  MemoryStick,
  Menu,
  MessageCircle,
  MessageSquare,
  Microwave,
  Milk,
  Monitor,
  Moon,
  Mountain,
  MountainSnow,
  Move,
  Newspaper,
  Notebook,
  Nut,
  Octagon,
  Package,
  Package2,
  Paintbrush,
  PaintbrushVertical,
  PaintBucket,
  PaintRoller,
  Palette,
  PartyPopper,
  Pencil,
  PencilRuler,
  Pentagon,
  Percent,
  Phone,
  PhoneCall,
  Pickaxe,
  PiggyBank,
  Pizza,
  Plane,
  Plug,
  Plug2,
  PlugZap,
  Popcorn,
  Power,
  PowerOff,
  Printer,
  Puzzle,
  Pyramid,
  QrCode,
  Rabbit,
  Radio,
  Rainbow,
  Receipt,
  RectangleHorizontal,
  RectangleVertical,
  Recycle,
  Refrigerator,
  Rocket,
  Route,
  Router,
  Rss,
  Ruler,
  RulerDimensionLine,
  Salad,
  Sandwich,
  Save,
  Scale,
  Scan,
  ScanLine,
  Scissors,
  Search,
  Section,
  Send,
  Settings,
  Share,
  Shell,
  Shield,
  ShieldCheck,
  Ship,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Shovel,
  ShowerHead,
  Siren,
  Slash,
  Smartphone,
  Smile,
  Snail,
  Snowflake,
  Sofa,
  Sparkles,
  Speaker,
  Sprout,
  Square,
  SquareParking,
  Squirrel,
  Star,
  Stethoscope,
  StickyNote,
  Store,
  Sun,
  Sunrise,
  Sunset,
  Syringe,
  Tablet,
  Target,
  Tent,
  TentTree,
  Thermometer,
  ThermometerSnowflake,
  ThermometerSun,
  ThumbsDown,
  ThumbsUp,
  Timer,
  Toilet,
  TrafficCone,
  TrainFront,
  Trash,
  Trash2,
  TreeDeciduous,
  TreePalm,
  TreePine,
  Trees,
  Triangle,
  TriangleAlert,
  Trophy,
  Truck,
  Tv,
  Umbrella,
  Usb,
  User,
  UserCheck,
  UserPlus,
  UserRound,
  Users,
  Utensils,
  UtensilsCrossed,
  Wallet,
  Wallpaper,
  Warehouse,
  WashingMachine,
  Watch,
  Waves,
  WavesLadder,
  Wifi,
  Wind,
  WindArrowDown,
  Wine,
  Wrench,
  Zap,
  ZapOff,
  type LucideIcon,
} from 'lucide-react'

import { ICON_GROUP_IDS, type IconGroupId } from '@brickup/shared/constants'

/**
 * The icons an admin may pick, in the groups the picker offers them in.
 *
 * A curated set rather than all of lucide: it keeps the grid scannable, and it
 * keeps tree-shaking working for the subset that actually ships.
 *
 * The group an icon sits in is the group the picker filters by, so adding one
 * is a single line in the right block — and a name that is nowhere is a build
 * error, because `ICON_REGISTRY` is derived from these blocks rather than
 * written a second time.
 */
const ICON_GROUP_ICONS = {
  building: {
    // Home & building shells
    House,
    HousePlug,
    HousePlus,
    HouseWifi,
    Building,
    Building2,
    Warehouse,
    Store,
    Castle,
    MapPin,
    MapPinHouse,
    Globe,
    Earth,
  },
  rooms: {
    // Rooms — sleeping / living
    Bed,
    BedDouble,
    BedSingle,
    Sofa,
    Armchair,
  },
  sanitary: {
    // Rooms — bath
    Bath,
    ShowerHead,
    Toilet,
    // Water / sanitary
    Droplet,
    Droplets,
    DropletOff,
    Waves,
    WavesLadder,
  },
  kitchen: {
    // Rooms — kitchen & dining
    Utensils,
    UtensilsCrossed,
    ChefHat,
    CookingPot,
    Coffee,
    CupSoda,
    Wine,
    Beer,
    Milk,
    Egg,
    // Food
    Pizza,
    Cake,
    CakeSlice,
    Cookie,
    Croissant,
    Sandwich,
    Salad,
    Hamburger,
    IceCreamCone,
    IceCreamBowl,
    Popcorn,
    Beef,
    Fish,
    Apple,
    Cherry,
    Grape,
    Carrot,
  },
  structure: {
    // Structure — doors, windows, walls, floors
    DoorClosed,
    DoorClosedLocked,
    DoorOpen,
    RectangleVertical,
    RectangleHorizontal,
    Square,
    Layers,
    Layers2,
    BrickWall,
    BrickWallFire,
    Fence,
    Section,
    Footprints,
    Wallpaper,
    // Layout
    LayoutGrid,
    LayoutList,
    LayoutDashboard,
  },
  electric: {
    // Electrical
    Plug,
    Plug2,
    PlugZap,
    Power,
    PowerOff,
    Zap,
    ZapOff,
    Cable,
    Antenna,
    Cctv,
    Wifi,
    Battery,
    BatteryCharging,
    BatteryFull,
    BatteryLow,
    BatteryMedium,
    BatteryWarning,
    Bolt,
    Nut,
    // Lighting
    Lightbulb,
    LightbulbOff,
    Lamp,
    LampCeiling,
    LampDesk,
    LampFloor,
    LampWallUp,
    LampWallDown,
  },
  climate: {
    // Heating / climate
    Flame,
    FlameKindling,
    Heater,
    Thermometer,
    ThermometerSun,
    ThermometerSnowflake,
    Snowflake,
    Sun,
    Wind,
    WindArrowDown,
    Fan,
    AirVent,
    // Weather
    Cloud,
    Cloudy,
    CloudRain,
    CloudDrizzle,
    CloudSnow,
    CloudSun,
    CloudLightning,
    CloudFog,
    Moon,
    Sunrise,
    Sunset,
    Umbrella,
    Rainbow,
  },
  tools: {
    // Tools & construction
    Hammer,
    Wrench,
    Drill,
    Shovel,
    Axe,
    Pickaxe,
    Paintbrush,
    PaintbrushVertical,
    PaintBucket,
    PaintRoller,
    Palette,
    Ruler,
    RulerDimensionLine,
    PencilRuler,
    Scissors,
    HardHat,
    Construction,
    TrafficCone,
    Forklift,
    Brush,
    BrushCleaning,
    Magnet,
    Gauge,
    Recycle,
    Settings,
    Component,
    Box,
    Boxes,
    Package,
    Package2,
    // Measurement & numbers
    Hash,
    Percent,
    Calculator,
    Scale,
    QrCode,
    Scan,
    ScanLine,
  },
  devices: {
    // Appliances & electronics
    WashingMachine,
    Refrigerator,
    Microwave,
    Printer,
    Tv,
    Speaker,
    Radio,
    Monitor,
    Laptop,
    Tablet,
    Smartphone,
    Watch,
    Camera,
    Cpu,
    HardDrive,
    HardDriveDownload,
    HardDriveUpload,
    MemoryStick,
    Usb,
    Bluetooth,
    Cast,
    Rss,
    Glasses,
    // Safety & security
    FireExtinguisher,
    AlarmSmoke,
    Bell,
    BellRing,
    Lock,
    LockKeyhole,
    LockOpen,
    Key,
    KeyRound,
    KeySquare,
    Shield,
    ShieldCheck,
    Siren,
    Eye,
    EyeOff,
    // Health
    Stethoscope,
    HeartPulse,
    Syringe,
    BriefcaseMedical,
    // Communication
    Mail,
    MailOpen,
    Mailbox,
    Inbox,
    MessageCircle,
    MessageSquare,
    Phone,
    PhoneCall,
    AtSign,
    Send,
    Share,
  },
  outdoor: {
    // Outdoor / garden / nature
    TreePine,
    TreeDeciduous,
    TreePalm,
    Trees,
    Leaf,
    LeafyGreen,
    Sprout,
    Flower,
    Flower2,
    Clover,
    Feather,
    Gem,
    Mountain,
    MountainSnow,
    Shell,
    // Animals
    Bird,
    Cat,
    Dog,
    Bug,
    Rabbit,
    Squirrel,
    Snail,
    // Vehicles & parking & travel
    Car,
    CarFront,
    Caravan,
    CircleParking,
    SquareParking,
    Bike,
    Bus,
    Truck,
    Ship,
    Plane,
    TrainFront,
    Anchor,
    Compass,
    Route,
    Router,
    Tent,
    TentTree,
    Luggage,
  },
  documents: {
    // Documents & planning
    File,
    FileText,
    FileCheck,
    FilePlus,
    FileMinus,
    FileX,
    FileAudio,
    FileVideo,
    FileImage,
    FileMusic,
    FileCode,
    Folder,
    FolderOpen,
    FolderPlus,
    FolderMinus,
    FolderCheck,
    FolderX,
    FolderKey,
    FolderLock,
    Archive,
    Clipboard,
    ClipboardCheck,
    ClipboardList,
    Book,
    BookOpen,
    Bookmark,
    Notebook,
    Newspaper,
    StickyNote,
    // Money & finance
    Banknote,
    Coins,
    CreditCard,
    Wallet,
    PiggyBank,
    Receipt,
    Euro,
    DollarSign,
    BadgeEuro,
    BadgeDollarSign,
    HandCoins,
    // Shopping
    ShoppingBag,
    ShoppingBasket,
    ShoppingCart,
    Shirt,
    // Time
    Clock,
    Timer,
    Hourglass,
    Calendar,
    CalendarCheck,
    CalendarClock,
    CalendarDays,
  },
  misc: {
    // People
    User,
    Users,
    UserCheck,
    UserPlus,
    UserRound,
    CircleUser,
    CircleUserRound,
    Contact,
    ContactRound,
    Hand,
    HandHeart,
    HandHelping,
    Handshake,
    // Faces
    Smile,
    Frown,
    Meh,
    // Actions & editing
    Pencil,
    Save,
    Copy,
    Search,
    Filter,
    Trash,
    Trash2,
    Check,
    CheckCheck,
    Move,
    Grip,
    GripHorizontal,
    GripVertical,
    Menu,
    Ellipsis,
    EllipsisVertical,
    Slash,
    ThumbsUp,
    ThumbsDown,
    // Status & symbols
    CircleCheck,
    CircleAlert,
    CircleX,
    CirclePower,
    CircleQuestionMark,
    TriangleAlert,
    Triangle,
    Hexagon,
    Octagon,
    Pentagon,
    Diamond,
    Cone,
    Cylinder,
    Pyramid,
    Info,
    Target,
    Crosshair,
    // Recreation & games
    Gamepad,
    Gamepad2,
    Dice1,
    Dice2,
    Dice3,
    Dice4,
    Dice5,
    Dice6,
    Puzzle,
    Dumbbell,
    // Achievement / generic
    Star,
    Heart,
    Flag,
    Sparkles,
    Trophy,
    Award,
    Medal,
    Rocket,
    Gift,
    PartyPopper,
    Briefcase,
  },
} satisfies Record<IconGroupId, Record<string, LucideIcon>>

/** Every icon by name, for `resolveIcon` and the grid. */
export const ICON_REGISTRY: Record<string, LucideIcon> = Object.assign(
  {},
  ...Object.values(ICON_GROUP_ICONS),
)

export { ICON_GROUP_IDS, type IconGroupId }

/** Which group an icon belongs to — the grid heads its blocks with it. */
export const ICON_GROUP_NAMES: Record<IconGroupId, string[]> =
  Object.fromEntries(
    ICON_GROUP_IDS.map(id => [id, Object.keys(ICON_GROUP_ICONS[id])]),
  ) as Record<IconGroupId, string[]>

/** Names available in the Icon-Picker. Sorted alphabetically for the UI. */
export const ICON_NAMES: string[] = Object.keys(ICON_REGISTRY).sort()

/** Historic keys that were stored in the DB but got merged/renamed. Kept out
 *  of the picker so the same glyph doesn't appear twice, but still resolvable
 *  so old rows don't fall back to `Square`. */
const LEGACY_ALIASES: Record<string, string> = {
  Home: 'House',
}

export function resolveIcon(name: string | null | undefined): LucideIcon {
  if (!name) return Square
  const resolved = LEGACY_ALIASES[name] ?? name
  return ICON_REGISTRY[resolved] ?? Square
}
